// Old admin surface for a single case study. The detail page now lives on
// the public site; send anyone landing on the admin path to the public page.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/case-studies/$id")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/case-studies/$id", params: { id: params.id } });
  },
});
